import React, { useMemo, useState } from "react";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import DatePickerField from "../../../../common/components/FormFields/DatePickerField";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import LoadingSpinner from "../../../../common/components/loadingspinner/loadingSpinner";
import CommonTransactionPaginationTable from "../../../../common/components/CommonTable/CommonTransactionPaginationTable";
import { useForm } from "react-hook-form";
import { styled, Tooltip } from "@mui/material";
import { fetchMachineWiseCycleDetailsList } from "../../../services/cssdCycleDetailsServices/CssdCycleDetailsServices";

const UserAction = [
  {
    id: 1,
    permission: "Create",
    isAction: false,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 3,
    permission: "Cancel",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 4,
    permission: "Print",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
  {
    id: 4,
    permission: "CheckOut",
    isAction: true,
    menuId: null,
    functionalityId: null,
    menuKey: null,
  },
];

const machineObj = [
  {
    "Sr. No.": 1,
    Kits: [
      "THYROID TRAY",
      "LAPAROSCOPY KIT",
      "Surgical Scissors",
      "Sterile Drapes",
      "Suction Tube",
      "Cotton Gauze",
    ],
    "Cycle No": "CY/2025/0001",
    "Start Time": "08/05/2025, 08:00 AM",
    "End Time": "08/05/2025, 08:30 AM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 132,
    Pressure: 15,
    "Average Time": "30 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 2,
    Kits: [
      "ENT Kit",
      "Eye Surgery Pack",
      "Surgical Gloves",
      "Scalpel Handle",
      "Orthopedic Set",
      "Suture Pack",
    ],
    "Cycle No": "CY/2025/0002",
    "Start Time": "08/05/2025, 09:00 AM",
    "End Time": "08/05/2025, 09:45 AM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 134,
    Pressure: 15,
    "Average Time": "45 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 3,
    Kits: [
      "General Surgery Kit",
      "Sterile Blades",
      "Irrigation Syringe",
      "Linen Pack",
      "Clamp Set",
      "Sponge Forceps",
    ],
    "Cycle No": "CY/2025/0003",
    "Start Time": "07/05/2025, 10:00 AM",
    "End Time": "07/05/2025, 10:35 AM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 131,
    Pressure: 15,
    "Average Time": "35 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 4,
    Kits: [
      "Cesarean Kit",
      "Amputation Set",
      "Drainage Set",
      "IV Cannula Pack",
      "Surgical Bowl",
      "Artery Forceps",
    ],
    "Cycle No": "CY/2025/0004",
    "Start Time": "07/05/2025, 11:15 AM",
    "End Time": "07/05/2025, 11:50 AM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 135,
    Pressure: 15,
    "Average Time": "35 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 5,
    Kits: [
      "Orthodontic Tray",
      "Dental Forceps",
      "Bone File Set",
      "Sterile Apron",
      "Dissecting Set",
      "Plastic Retractors",
    ],
    "Cycle No": "CY/2025/0005",
    "Start Time": "07/05/2025, 12:00 PM",
    "End Time": "07/05/2025, 12:45 PM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 134,
    Pressure: 15,
    "Average Time": "45 Min",
    Status: "Fail",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 6,
    Kits: [
      "Delivery Set",
      "Gynaecology Set",
      "Urine Bag",
      "Sterile Towels",
      "Probe Set",
      "Needle Holder",
    ],
    "Cycle No": "CY/2025/0006",
    "Start Time": "07/05/2025, 01:00 PM",
    "End Time": "07/05/2025, 01:40 PM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 130,
    Pressure: 15,
    "Average Time": "40 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 7,
    Kits: [
      "Neurosurgery Kit",
      "Hemostat Clamp",
      "Bone Cutter",
      "Suction Catheter",
      "Eye Shield",
      "Surgical Apron",
    ],
    "Cycle No": "CY/2025/0007",
    "Start Time": "07/05/2025, 02:00 PM",
    "End Time": "07/05/2025, 02:30 PM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 133,
    Pressure: 15,
    "Average Time": "30 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 8,
    Kits: [
      "ENT Diagnostic Set",
      "Artery Clamp",
      "Gauze Roll",
      "Instrument Tray",
      "Sterile Gloves",
      "Scalpels",
    ],
    "Cycle No": "CY/2025/0008",
    "Start Time": "07/05/2025, 03:00 PM",
    "End Time": "07/05/2025, 03:30 PM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 134,
    Pressure: 15,
    "Average Time": "30 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 9,
    Kits: [
      "Vascular Set",
      "Needle Pack",
      "Towel Clips",
      "Gastro Tray",
      "Kidney Dish",
      "Ortho Drill Kit",
    ],
    "Cycle No": "CY/2025/0009",
    "Start Time": "07/05/2025, 04:00 PM",
    "End Time": "07/05/2025, 04:35 PM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 132,
    Pressure: 15,
    "Average Time": "35 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
  {
    "Sr. No.": 10,
    Kits: [
      "Cautery Set",
      "Sterile Jar",
      "Surgical Clips",
      "Syringe Tray",
      "Medical Drapes",
      "Speculum",
    ],
    "Cycle No": "CY/2025/0010",
    "Start Time": "07/05/2025, 05:00 PM",
    "End Time": "07/05/2025, 05:45 PM",
    Method: "steam sterilization(autoclave)",
    "Temp. (°C)": 135,
    Pressure: 15,
    "Average Time": "45 Min",
    Status: "Pass",
    Operator: "Omkar Patil",
  },
];

function CSSDMachine() {
  const defaultValues = {
    machine: null,
    fromdate: null,
    toDate: null,
  };
  const { control, watch, setValue, register, reset } = useForm({
    mode: "onChange",
    defaultValues,
  });

  const [dataResult, setDataResult] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState(null);
  const [isShowSpinner, setIsShowSpinner] = useState(false);
  const [searchString, setSearchString] = useState(null);
  const [listingObject, setListingObject] = useState({
    machineId: null,
    fromDate: null,
    toDate: null,
  });

  let getFromDate = watch("fromdate");
  let getToDate = watch("toDate");
  let getMachine = watch("machine");

  const populateTable = (forPagination) => {
    let listObj = {
      fromDate: getFromDate,
      toDate: getToDate,
      machineId: getMachine ? getMachine?.id : null,
      page: page,
      size: rowsPerPage,
    };
    fetchMachineWiseCycleDetailsList(listObj).then((response) => {
      if (forPagination) {
        setDataResult((prevData) => [
          ...prevData,
          JSON.parse(...response.data.result)?.map((val) => ({
            "Sr. No.": val?.["Sr. No."],
            Kits: val?.Kits,
            "Cycle No": val?.["Cycle No"],
            "Start Time": val?.["Start Time"],
            "End Time": val?.["End Time"],
            "Sterilization Method": val?.["Sterilization Method"],
            Machine: val?.Machine,
            "Temp. (°C)": val?.["Temp. (°C)"],
            Pressure: val?.Pressure,
            "Average Time": val?.["Average Time"],
            Status: val?.Status,
            "Operator Name": val?.["Operator Name"],
          })),
        ]);
      } else {
        setDataResult(
          JSON.parse(response.data.result)?.map((val) => ({
            "Sr. No.": val?.["Sr. No."],
            Kits: val?.Kits,
            "Cycle No": val?.["Cycle No"],
            "Start Time": val?.["Start Time"],
            "End Time": val?.["End Time"],
            "Sterilization Method": val?.["Sterilization Method"],
            Machine: val?.Machine,
            "Temp. (°C)": val?.["Temp. (°C)"],
            Pressure: val?.Pressure,
            "Average Time": val?.["Average Time"],
            Status: val?.Status,
            "Operator Name": val?.["Operator Name"],
          }))
        );
        setPage(0);
      }
      setCount(response.data.count);
    });
  };
  const CustomTooltip = styled(({ className, ...props }) => (
    <Tooltip
      {...props}
      arrow
      placement="right"
      classes={{ popper: className }}
    />
  ))(({ theme }) => ({
    [`& .MuiTooltip-tooltip`]: {
      backgroundColor: "#073763",
      color: "white",
      Padding: 0,
      boxShadow: theme.shadows[1],
      fontSize: 13,
    },
    [`& .MuiTooltip-arrow`]: {
      color: "#073763",
    },
  }));

  const renderInput = (row, index, header) => {
    return (
      <>
        {header === "Status" && (
          <button
            className={`h-6 w-24 whitespace-nowrap border rounded capitalize px-5 text-center
                     ${row?.Status === "Success"
                ? "text-[#3FC28A] bg-[#ECF9F3] border-[#3FC28A]"
                : "text-[#EF1212] bg-[#EF12121A] border-[#EF1212]"
              }`}
            type="button"
          >
            {row?.Status}
          </button>
        )}

        {header === "Kits" && (
          <div className="inline-flex items-center cursor-pointer space-x-2">
            <CustomTooltip
              title={
                row?.Kits?.length > 2 ? (
                  <div className=" bg-white -mx-1.5 -my-0.5 rounded ">
                    {row.Kits?.slice(2).map((val, index) => (
                      <div>
                        <p key={index} className=" text-black px-2">
                          <span className="text-center text-lg align-middle mr-1  text-[#3c9c23b7]">
                            •
                          </span>
                          {val}
                        </p>
                        <hr />
                      </div>
                    ))}
                  </div>
                ) : (
                  ""
                )
              }
              placement="left-start"
              sx={{ fontSize: "0.75rem" }}
            >
              {row?.Kits?.slice(0, 2)?.map((val, index) => (
                <p key={index} className="inline-flex items-center space-x-2">
                  <span className="text-center text-lg align-middle mx-1 text-[#3c9c23b7]">
                    •
                  </span>
                  {val}
                </p>
              ))}
              {row?.Kits?.length > 2 && (
                <p className="inline-flex items-center space-x-2 text-gray-500 cursor-pointer">
                  ...
                </p>
              )}
            </CustomTooltip>
          </div>
        )}
      </>
    );
  };

  useMemo(() => {
    populateTable();
  }, [
    listingObject?.machineId,
    listingObject?.fromDate,
    listingObject?.toDate,
  ]);

  return (
    <div>
      <div>
        <div className="grid md:grid-cols-2 lg:grid-cols-4  gap-2">
          <div className="w-full md:w-3/3 lg:w-full ">
            <DropdownField
              control={control}
              name="machine"
              placeholder="Machine"
              dataArray={[
                { id: 1, label: "AUTOCLAVE 01", value: "AUTOCLAVE01" },
                { id: 2, label: "AUTOCLAVE 02", value: "AUTOCLAVE01" },
                { id: 3, label: "AUTOCLAVE 03", value: "AUTOCLAVE01" },
                { id: 4, label: "AUTOCLAVE 04", value: "AUTOCLAVE01" },
                { id: 5, label: "AUTOCLAVE 05", value: "AUTOCLAVE01" },
              ]}
              isClearable={true}
              isSearchable={true}
            />
          </div>

          <div className="grid grid-cols-2 items-center gap-x-2">
            <DatePickerField
              name="fromdate"
              label="From Date"
              control={control}
              inputFormat="dd-MM-yyyy"
            />
            <DatePickerField
              name="toDate"
              label="To Date"
              control={control}
              inputFormat="dd-MM-yyyy"
            />
          </div>
          <div className="flex justify-between lg:col-span-2 ">
            <div className="flex  flex-wrap  gap-2">
              <CommonButton
                searchIcon={true}
                type={"button"}
                className={"px-4 rounded-md bg-customBlue text-white"}
                onClick={() => {
                  setListingObject((listingObject) => ({
                    ...listingObject,
                    fromDate: getFromDate,
                    toDate: getToDate,
                    machineId: getMachine?.id,
                  }));
                }}
              />
              <CommonButton
                label={"Reset"}
                className=" border border-customRed text-customRed "
                type={"button"}
                onClick={() => {
                  reset();
                }}
              />
            </div>
          </div>
        </div>

        <div className="">
          {isShowSpinner ? (
            <div className="flex justify-center my-28">
              <LoadingSpinner />
            </div>
          ) : (
            <div>
              {dataResult && dataResult.length > 0 ? (
                <CommonTransactionPaginationTable
                  dataResult={dataResult}
                  rowsPerPage={rowsPerPage}
                  renderInput={renderInput}
                  setPage={setPage}
                  tableClass="capitalize"
                  count={count}
                  page={page}
                  populateTable={populateTable}
                  highlightRow={false}
                  setRowsPerPage={setRowsPerPage}
                  removeHeaders={["Status", "Sr. No."]}
                  editableColumns={["Status", "Kits"]}
                />
              ) : (
                <>
                  {!isShowSpinner && (
                    <p className="text-center  my-28 w-full text-gray-600">
                      No Record Found<span className="animate-pulse">...</span>
                    </p>
                  )}
                </>
              )}
            </div>
          )}
        </div>
        
      </div>
    </div>
  );
}

export default CSSDMachine;